import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "@/lib/book";

const AuthCtx = createContext({ user: null, loading: true, logout: () => {}, refresh: () => {} });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/auth/me`, { withCredentials: true });
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(async () => {
    try { await axios.post(`${API}/auth/logout`, {}, { withCredentials: true }); } catch {}
    setUser(null);
    window.location.href = "/login";
  }, []);

  useEffect(() => {
    // Skip /auth/me when returning from Emergent OAuth (AuthCallback handles it)
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  return (
    <AuthCtx.Provider value={{ user, loading, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
